/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { GeofenceLayer, geofenceLayerFromJSON, geofenceLayerToJSON } from "../../../../tools/cloud_config/site_info";

export const protobufPackage = "skills";

export interface GeofenceConfigActionArgs {
  /** Map of geofence filename to desired layer. */
  fileToGeofenceLayer: { [key: string]: GeofenceLayer };
}

export interface GeofenceConfigActionArgs_FileToGeofenceLayerEntry {
  key: string;
  value: GeofenceLayer;
}

export interface GeofenceConfigResultData {
}

export interface GeofenceConfigActionStateData {
}

function createBaseGeofenceConfigActionArgs(): GeofenceConfigActionArgs {
  return { fileToGeofenceLayer: {} };
}

export const GeofenceConfigActionArgs = {
  encode(message: GeofenceConfigActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    Object.entries(message.fileToGeofenceLayer).forEach(([key, value]) => {
      GeofenceConfigActionArgs_FileToGeofenceLayerEntry.encode({ key: key as any, value }, writer.uint32(10).fork())
        .ldelim();
    });
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GeofenceConfigActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGeofenceConfigActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          const entry1 = GeofenceConfigActionArgs_FileToGeofenceLayerEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.fileToGeofenceLayer[entry1.key] = entry1.value;
          }
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GeofenceConfigActionArgs {
    return {
      fileToGeofenceLayer: isObject(object.fileToGeofenceLayer)
        ? Object.entries(object.fileToGeofenceLayer).reduce<{ [key: string]: GeofenceLayer }>((acc, [key, value]) => {
          acc[key] = geofenceLayerFromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: GeofenceConfigActionArgs): unknown {
    const obj: any = {};
    if (message.fileToGeofenceLayer) {
      const entries = Object.entries(message.fileToGeofenceLayer);
      if (entries.length > 0) {
        obj.fileToGeofenceLayer = {};
        entries.forEach(([k, v]) => {
          obj.fileToGeofenceLayer[k] = geofenceLayerToJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GeofenceConfigActionArgs>, I>>(base?: I): GeofenceConfigActionArgs {
    return GeofenceConfigActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GeofenceConfigActionArgs>, I>>(object: I): GeofenceConfigActionArgs {
    const message = createBaseGeofenceConfigActionArgs();
    message.fileToGeofenceLayer = Object.entries(object.fileToGeofenceLayer ?? {}).reduce<
      { [key: string]: GeofenceLayer }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = value as GeofenceLayer;
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseGeofenceConfigActionArgs_FileToGeofenceLayerEntry(): GeofenceConfigActionArgs_FileToGeofenceLayerEntry {
  return { key: "", value: 0 };
}

export const GeofenceConfigActionArgs_FileToGeofenceLayerEntry = {
  encode(
    message: GeofenceConfigActionArgs_FileToGeofenceLayerEntry,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(16).int32(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GeofenceConfigActionArgs_FileToGeofenceLayerEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGeofenceConfigActionArgs_FileToGeofenceLayerEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.value = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GeofenceConfigActionArgs_FileToGeofenceLayerEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? geofenceLayerFromJSON(object.value) : 0,
    };
  },

  toJSON(message: GeofenceConfigActionArgs_FileToGeofenceLayerEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = geofenceLayerToJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GeofenceConfigActionArgs_FileToGeofenceLayerEntry>, I>>(
    base?: I,
  ): GeofenceConfigActionArgs_FileToGeofenceLayerEntry {
    return GeofenceConfigActionArgs_FileToGeofenceLayerEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GeofenceConfigActionArgs_FileToGeofenceLayerEntry>, I>>(
    object: I,
  ): GeofenceConfigActionArgs_FileToGeofenceLayerEntry {
    const message = createBaseGeofenceConfigActionArgs_FileToGeofenceLayerEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseGeofenceConfigResultData(): GeofenceConfigResultData {
  return {};
}

export const GeofenceConfigResultData = {
  encode(_: GeofenceConfigResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GeofenceConfigResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGeofenceConfigResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GeofenceConfigResultData {
    return {};
  },

  toJSON(_: GeofenceConfigResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GeofenceConfigResultData>, I>>(base?: I): GeofenceConfigResultData {
    return GeofenceConfigResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GeofenceConfigResultData>, I>>(_: I): GeofenceConfigResultData {
    const message = createBaseGeofenceConfigResultData();
    return message;
  },
};

function createBaseGeofenceConfigActionStateData(): GeofenceConfigActionStateData {
  return {};
}

export const GeofenceConfigActionStateData = {
  encode(_: GeofenceConfigActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GeofenceConfigActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGeofenceConfigActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GeofenceConfigActionStateData {
    return {};
  },

  toJSON(_: GeofenceConfigActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GeofenceConfigActionStateData>, I>>(base?: I): GeofenceConfigActionStateData {
    return GeofenceConfigActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GeofenceConfigActionStateData>, I>>(_: I): GeofenceConfigActionStateData {
    const message = createBaseGeofenceConfigActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
